import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-actions-rent-info',
  templateUrl: './actions-rent-info.component.html',
  styleUrls: ['./actions-rent-info.component.scss']
})
export class ActionsRentInfoComponent implements OnInit {
  @Input() infoRentData;
  informationForm: FormGroup;

  // File variables
  fileImg64: string | ArrayBuffer;
  wrongSize: any[] = [];
  constructor() { }

  ngOnInit(): void {
  }

}
